module.exports = __webpack_public_path__ + "assets/arrow-down.ae3bc75.png";